// extracted by mini-css-extract-plugin
export default {"form":"login-form_form__hB9Ms","title":"login-form_title__rOfZm","description":"login-form_description__UlVBG","forgot":"login-form_forgot__mGyCL"};